import type { GetStaticProps, InferGetStaticPropsType } from 'next';

import { StaticSeoHomepage, type StaticSeoHomepageProps } from '@/components/public-site/StaticSeoHomepage';
import { loadStaticHomepageMessages } from '@/lib/seo/static-homepage-data';

export const getStaticProps: GetStaticProps<StaticSeoHomepageProps> = async () => ({
  props: {
    locale: 'en',
    messages: await loadStaticHomepageMessages('en'),
  },
  revalidate: 600,
});

export default function EnglishHomepage(
  props: InferGetStaticPropsType<typeof getStaticProps>,
) {
  return <StaticSeoHomepage {...props} />;
}
